import { useCallback } from 'react';
import { useCurrencyStore } from '../../../stores/currency';

/**
 * The org side of the packages' "money arrives pre-formatted" contract.
 *
 * Separate from the quote client view's `useMoney`, which reads the currency a
 * QUOTE is priced in. An order has its own — the one the client picked in the
 * app chrome — so borrowing the quote's hook would price a delivered order in
 * whatever currency the last quote happened to use.
 */
export function useMoney() {
	const { selectedCurrency } = useCurrencyStore();
	return useCallback(
		(
			amount: number | null | undefined,
			currency?: string | null,
			/** A per-piece price: up to 4 decimals when the figure needs them. */
			opts?: { unit?: boolean }
		): string | null => {
			if (amount == null) return null;
			// Totals always at 2 decimals — never "DKK 12.5".
			return new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: currency || selectedCurrency,
				minimumFractionDigits: 2,
				maximumFractionDigits: opts?.unit ? 4 : 2,
			}).format(amount);
		},
		[selectedCurrency]
	);
}
